import React from 'react';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

export let stripePromise: Promise<Stripe | null>;

export default function withStripe<P>(WrappedComponent: React.FC<P>): React.FC<P> {
  return function WrappedWithStripe(props: P) {
    if (!stripePromise)
      stripePromise = loadStripe(process.env.STRIPE_API_KEY, {
        apiVersion: '2020-08-27', // TODO: remove after upgrading version in stripe dashboard
      });
    return (
      <Elements stripe={stripePromise}>
        <WrappedComponent {...(props as P)} />
      </Elements>
    );
  };
}
